import { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useAppSelector } from "../redux/store";
import { selectAuth } from "../redux/auth/auth.selector";
import { Paths } from "../routes/paths";
import { RoleType } from "../types/user.types";

type Props = {
  children: ReactNode;
  roles?: RoleType[];
};

const AuthGuard = ({ children, roles }: Props) => {
  const { isAuthorized, isInitialized, user } = useAppSelector(selectAuth);

  if (!isInitialized) {
    return <h1>Loading...</h1>; // או null
  }

  if (!isAuthorized) {
    return <Navigate to={`/${Paths.login}`} />;
  }

  if (roles && roles.length && !roles.includes(user!.role)) {
    return <h1>unauthorized</h1>; // או ניווט לדף 403
  }

  return <>{children}</>;
};

export default AuthGuard;
